"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModelContainer = void 0;
var lodash_1 = require("lodash");
var mobx_1 = require("mobx");
var Context_1 = require("../Context");
var ModelContainer = /** @class */ (function () {
    function ModelContainer(modelClass) {
        var _this = this;
        this.modelClass = modelClass;
        this.loading = false;
        this.loaded = false;
        this.setError = function (e) { return (_this.error = e); };
        this.setLoading = function (loading) { return (_this.loading = loading); };
        this.setLoaded = function (loaded) { return (_this.loaded = loaded); };
    }
    Object.defineProperty(ModelContainer.prototype, "hasError", {
        get: function () {
            return !!this.error;
        },
        enumerable: false,
        configurable: true
    });
    ModelContainer.prototype.load = function (url, params, config) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            var dataKey, forceRefresh, isSameUrl, areSameParams, isSameRequest, response, data, e_1;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        dataKey = ((_a = config === null || config === void 0 ? void 0 : config.dataKey) !== null && _a !== void 0 ? _a : 'data');
                        forceRefresh = config && config.forceRefresh;
                        isSameUrl = this.url === url;
                        areSameParams = (!this.params && !params) || lodash_1.isEqual(this.params, params);
                        isSameRequest = isSameUrl && areSameParams;
                        if (isSameRequest && this.loaded && !forceRefresh) {
                            return [2 /*return*/];
                        }
                        // if (this.loading) {
                        //     if (isSameRequest) {
                        //         return;
                        //     }
                        //     this.apiService.cancelRequest(this.requestId!);
                        // }
                        this.setError(null);
                        this.setLoaded(false);
                        this.setLoading(true);
                        this.url = url;
                        this.params = params;
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, Context_1.ContextStatic.default.apiService.get(url, {
                                params: params,
                                extras: { useAuth: config === null || config === void 0 ? void 0 : config.useAuth },
                            })];
                    case 2:
                        response = _c.sent();
                        data = (_b = response[dataKey]) !== null && _b !== void 0 ? _b : response;
                        if ((config === null || config === void 0 ? void 0 : config.paginated) === true) {
                            this.onSuccess(response);
                        }
                        else {
                            this.onSuccess(data);
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _c.sent();
                        this.onError(e_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    ModelContainer.prototype.onSuccess = function (response) {
        this.setLoaded(true);
        this.setLoading(false);
        this.deserialize(response);
    };
    ModelContainer.prototype.onError = function (error) {
        this.setLoaded(true);
        this.setLoading(false);
        this.setError(error);
        throw error;
    };
    __decorate([
        mobx_1.observable
    ], ModelContainer.prototype, "error", void 0);
    __decorate([
        mobx_1.observable
    ], ModelContainer.prototype, "loading", void 0);
    __decorate([
        mobx_1.observable
    ], ModelContainer.prototype, "loaded", void 0);
    __decorate([
        mobx_1.computed
    ], ModelContainer.prototype, "hasError", null);
    __decorate([
        mobx_1.action
    ], ModelContainer.prototype, "setError", void 0);
    __decorate([
        mobx_1.action
    ], ModelContainer.prototype, "setLoading", void 0);
    __decorate([
        mobx_1.action
    ], ModelContainer.prototype, "setLoaded", void 0);
    __decorate([
        mobx_1.action
    ], ModelContainer.prototype, "load", null);
    __decorate([
        mobx_1.action
    ], ModelContainer.prototype, "onSuccess", null);
    __decorate([
        mobx_1.action
    ], ModelContainer.prototype, "onError", null);
    return ModelContainer;
}());
exports.ModelContainer = ModelContainer;
